
/**
 * Module dependencies.
 */

import { dividerColor } from './footer-theme';
import { media, units } from 'src/styles/utils';
import { useFooterSocialLinks } from 'src/core/menu';
import { useTranslate } from 'src/core/utils/translator';
import FooterColumn from './footer-column';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  ${media.min('md')`
    border-left: 1px solid ${dividerColor};
    flex: none;
    padding-left: ${units(5)};
    width: ${units(21.175)};
  `}
`;

/**
 * `SocialLinks` component.
 *
 * The `Siga-nos` column. The urls are managed in the back office through
 * `site-configs`; a network without a url is not listed.
 */

const SocialLinks = (): ReactElement | null => {
  const { translate } = useTranslate();
  const links = useFooterSocialLinks();

  if (!links.length) {
    return null;
  }

  return (
    <Wrapper>
      <FooterColumn
        links={links}
        title={translate('footer:socialMedia.title')}
      />
    </Wrapper>
  );
};

/**
 * Export `SocialLinks` component.
 */

export default SocialLinks;
